<template>
  <Head :title="event.title" />

  <main class="events view">
    <section>
      <header>
        <div>
          <h2>Agenda</h2>
          <h1>{{ event.title }}</h1>
        </div>

        <div class="actions">
          <Link v-if="event.can.update" class="button" :href="event.links.update">
            <Icon name="edit" />
            {{ $t('update') }}
          </Link>

          <Dropdown v-if="event.can.delete">
            <ul role="menu" aria-hidden="true">
              <li v-if="event.can.delete" role="menuitem">
                <button v-close-popper type="button" class="danger" @click.prevent="deleteEvent">
                  <Icon name="trash" />
                  verwijder
                </button>
              </li>
            </ul>
          </Dropdown>
        </div>
      </header>

      <dl>
        <div>
          <dt>datum</dt>
          <dd>
            <DateTime :datetime="event.date" />
          </dd>
        </div>

        <div>
          <dt>locatie / restaurant</dt>
          <dd>
            {{ event.location }}
          </dd>
        </div>

        <div>
          <dt>status</dt>
          <dd>{{ event.status.label }}</dd>
        </div>

        <div>
          <dt>omschrijving</dt>
          <dd>
            <article class="prose pre">
              {{ event.description }}
            </article>
          </dd>
        </div>
      </dl>
    </section>
  </main>
</template>

<script lang="ts" setup>
import { Head, Link, router } from '@inertiajs/vue3'
import { toast } from 'vue-sonner'

import DateTime from '/@admin:components/DateTime.vue'
import Dropdown from '/@admin:components/Dropdown.vue'
import Icon from '/@admin:components/Icon.vue'
import { deleteConfirm } from '/@admin:composables/deleteConfirm'
import AuthLayout from '/@admin:layouts/Auth.vue'
import { http } from '/@admin:shared/http'
import { $t } from '/@admin:shared/i18n'
import type { Authorizable, Event } from '/@admin:types'

defineOptions({
  layout: [AuthLayout],
})

const props = defineProps<{
  event: Authorizable & Event
  links: Record<string, string>
}>()

const deleteEvent = () => {
  deleteConfirm(props.event.title, {
    icon: 'calendar-x',
    action: async () => {
      await http.delete(props.event.links.view)

      toast.success(
        $t('Deleted :name.', {
          name: props.event.title,
        }),
      )

      router.visit(props.links.index)
    },
  })
}
</script>
